export function ScoutIcon({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="sg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FB923C" />
          <stop offset="100%" stopColor="#EA580C" />
        </linearGradient>
      </defs>
      {/* Speech bubble circle */}
      <path
        d="M50 4C25.1 4 5 22.9 5 46c0 12.6 5.6 23.9 14.6 31.8L14 96l20.2-7.4C38.6 90.2 44.2 91 50 91c24.9 0 45-18.9 45-45S74.9 4 50 4z"
        fill="url(#sg)"
      />
      {/* Left antenna stem */}
      <rect x="35" y="16" width="3" height="14" rx="1.5" fill="white" />
      {/* Left antenna tip */}
      <circle cx="36.5" cy="14" r="4" fill="white" />
      {/* Right antenna stem */}
      <rect x="62" y="16" width="3" height="14" rx="1.5" fill="white" />
      {/* Right antenna tip */}
      <circle cx="63.5" cy="14" r="4" fill="white" />
      {/* Robot head */}
      <rect x="28" y="30" width="44" height="36" rx="10" fill="white" />
      {/* Left eye */}
      <circle cx="40" cy="44" r="5" fill="url(#sg)" />
      {/* Right eye */}
      <circle cx="60" cy="44" r="5" fill="url(#sg)" />
      {/* Smile */}
      <path
        d="M38 56 Q50 66 62 56"
        stroke="url(#sg)"
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
      />
      {/* Left ear */}
      <rect x="22" y="38" width="7" height="14" rx="3.5" fill="white" />
      {/* Right ear */}
      <rect x="71" y="38" width="7" height="14" rx="3.5" fill="white" />
    </svg>
  );
}